export default __webpack_public_path__ + "static/media/six.9325ea45.png";